const API_BASE = 'https://roulette-api.rushelsilvester.workers.dev';

async function request(method, path, body, token) {
  try {
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const res = await fetch(`${API_BASE}${path}`, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });
    return await res.json();
  } catch (err) {
    console.error('API error:', method, path, err);
    return { error: err.message || 'Network error' };
  }
}

export const api = {
  createRoom: (opts) => request('POST', '/api/rooms', opts),
  getState: (code, token) => request('GET', `/api/rooms/${code}`, null, token),
  join: (code, name) => request('POST', `/api/rooms/${code}/join`, { name }),
  bet: (code, bet, token) => request('POST', `/api/rooms/${code}/bet`, bet, token),
  startSpin: (code, params, token) => request('POST', `/api/rooms/${code}/start-spin`, params, token),
  spin: (code, number, token) => request('POST', `/api/rooms/${code}/spin`, { number }, token),
  newRound: (code, token) => request('POST', `/api/rooms/${code}/new-round`, null, token),
  closeBets: (code, token) => request('POST', `/api/rooms/${code}/close-bets`, null, token),
  settings: (code, settings, token) => request('POST', `/api/rooms/${code}/settings`, settings, token),
  checkin: (code, name, balance, token) => request('POST', `/api/rooms/${code}/checkin`, { name, balance }, token),
  checkout: (code, playerId, token) => request('POST', `/api/rooms/${code}/players/${playerId}/checkout`, null, token),
  kickPlayer: (code, playerId, token) => request('POST', `/api/rooms/${code}/players/${playerId}/kick`, null, token),
};
